import { Stack, Typography, useTheme } from "@mui/material";
import React from "react";

const Section2 = ({ primary }) => {
  const { section_header, section_description } = primary;
  const theme = useTheme();

  return (
    <Stack
      sx={{
        backgroundColor: theme.palette.primary.dark,
        alignItems: "center",
        justifyContent: "center",
        pt: "156px",
        pb: "80px",
        px: "20px",
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: "36px",
          fontWeight: "bold",
          color: theme.palette.secondary.light,
          textAlign: "center",
          mb: 1,
        }}
      >
        {section_header.text}
      </Typography>

      <Typography
        sx={{
          fontSize: "18px",
          color: theme.palette.secondary.light,
          maxWidth: "450px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {section_description.text}
      </Typography>
    </Stack>
  );
};

export default Section2;
